<template>
  <b-field>
    <template #label>
      {{ label }}
      <b-tooltip type="is-dark" :label="tooltip">
        <b-icon size="is-small" icon="info-circle"></b-icon>
      </b-tooltip>
    </template>
    <label class="control color-picker-wraper">
      <span class="input" :style="{ backgroundColor: componentValue }">
        <b-icon
          icon-pack="fa"
          icon="pen"
          style="color: #ffffff"
          size="is-small"
        ></b-icon>
        <input
          v-model="componentValue"
          class="native-color-input"
          type="color"
          @blur="$emit('blur', componentValue)"
        />
      </span>
    </label>
    <b-input
      v-model="componentValue"
      class="color-text-input"
      type="text"
      expanded
      @blur="$emit('blur', componentValue)"
    />
  </b-field>
</template>

<script>
export default {
  name: "ColorPicker",
  props: {
    value: {
      default: "#000000",
    },
    label: null,
    tooltip: null,
  },
  emits: ["input", "blur"],
  computed: {
    componentValue: {
      get() {
        // /^#(?:[a-f0-9]{3}){1,2}$/i // color match regex
        if (this.value && !/^\#.*$/i.test(this.value)) {
          return "#" + this.value;
        }
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
  },
};
</script>

<style scoped lang="scss">
.color-picker-wraper {
  position: relative;
  box-sizing: border-box;
  width: 40px;
  border-radius: 8px;
  cursor: pointer;

  &.control:first-child:not(:only-child) {
    border-bottom-right-radius: 0;
    border-top-right-radius: 0;
  }

  .input {
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .native-color-input {
    position: absolute;
    bottom: 0px;
    left: 50%;
    width: 0px;
    height: 0px;
    border: none;
    padding: 0;
    margin: 0;
    opacity: 0;
  }
}
</style>

<style lang="scss">
.color-text-input > input {
  text-transform: uppercase;
}
</style>
